<template>
  <div>
    <oil-form v-if="loading"
              :title="formTitle.toUpperCase()"
              :keys="keys"
              :items="invoice"
              :createForm="!id || !invoice.Id"
              :formCallback="formCallBack"
              @WaybillId='changeWaybill'
    >
      <template v-slot:header="{id}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="id" class="mx-8" type="button" icon
                   @click="showMePdf('invoice/print',invoice.Id || id)"
                   v-bind="attrs"
                   v-on="on"
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Buyer.Id="{rules,input}">
        <v-autocomplete
            :items="buyers$"
            v-stream:keyup.native="searchCompany$"
            hide-no-data
            class="z-index"
            :disabled="!input.isEdit"
            clearable
            :rules="[...rules]"
            dense
            outlined
            @change="changeBuyer"
            hide-selected
            :value="invoice.Buyer.CompanyName"
            item-text="CompanyName"
            label="Выбрать покупателя"
            return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Contract.Id="{rules,input}">
        <v-autocomplete
            :items="contracts$"
            v-stream:keyup.native="searchContract$"
            hide-no-data
            :disabled="!input.isEdit"
            class="z-index"
            :rules="[...rules]"
            clearable
            @change="changeContract"
            dense
            outlined
            :value="invoice.Contract.Number"
            hide-selected
            item-text="Number"
            label="Выбрать договор"
            return-object
        ></v-autocomplete>
      </template>
    </oil-form>
  </div>
</template>

<script>
import {form} from '@/pages/setting/invice_show.json'
import {invoiceService} from '@/services/InvoiceService'
import {companiesService} from '@/services/CompaniesService'
import {contractsService} from '@/services/ContractsService'
import {waybillService} from '@/services/WayBillService'
import {debounceTime, distinctUntilChanged, filter, pluck, switchMap} from "rxjs/operators";
import {coreApi} from "@/services/core";

export default {
  props: {
    id: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  domStreams: ['searchCompany$', 'searchContract$'],
  subscriptions() {
    return {
      contracts$: this.searchContract$.pipe(
          pluck('event', 'target', 'value'),
          debounceTime(200),
          distinctUntilChanged(),
          switchMap(query => coreApi.get(`contract/search/number?pattern=${query}`)),
          pluck('data')
      ),
      buyers$: this.searchCompany$.pipe(
          pluck('event', 'target', 'value'),
          debounceTime(200),
          filter(value => value.length > 2),
          debounceTime(100),
          distinctUntilChanged(),
          switchMap(query => coreApi.get(`company/search/name?pattern=${query}`)),
          pluck('data')
      )
    }
  },
  data: () => ({
    formTitle: 'Создать счет фактуру',
    keys: form.keys,
    invoice: {
      Comment: '',
      Number: '',
      InvoiceDate: '',
      Executor: 'mock',
      Buyer: {
        Id: ''
      },
      Seller: {},
      Contract: {
        Id: '',
        Number: ''
      },
      // Appendix: {
      //   Id: '',
      //   Number: ''
      // },
      Waybill: {
        Id: '',
        Number: ''
      }
    },
    loading: false,
  }),
  async created() {
    const companies = await companiesService.getAll()
    this.buyers$ = companies.data
    if (this.id) {
      this.formTitle = 'Инфо о счет фактуре'
      const invoice = await invoiceService.getInvoices({id: this.id})
      if (!invoice.data) {
        this.$router.back()
        return
      }
      this.invoice = invoice.data
      this.keys.Number.attrs.readonly = true
      const bid = this.invoice.Buyer.Id
      const contractId = this.invoice.Contract.Id
      const ttn = await waybillService.getCompanyById(bid)
      this.keys["Waybill.Id"].attrs.items = ttn.data
      const contracts = await contractsService.contractCompanyById({companyid: bid})
      this.contracts$ = contracts.data
      const contract = contracts.data.find(({Id}) => Id === contractId)
      // this.keys["Appendix.Id"].attrs.items = contract?.Appendixes
    }
    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? invoiceService.update : invoiceService.create
    }
  },
  methods: {
    async changeBuyer(buyer) {
      if (!buyer) return
      const id = buyer.Id
      this.invoice.Buyer = {...buyer}
      const contractId = this.invoice.Contract.Id
      this.invoice.Contract = {
        Id: '',
        Number: ''
      }
      // this.invoice.Appendix = {
      //   Id: '',
      //   Number: ''
      // }
      this.invoice.Waybill = {
        Id: '',
        Number: ''
      }
      const contracts = await contractsService.contractCompanyById({companyId: buyer.Id})
      this.contracts$ = contracts.data
      const contract = contracts.data.find(({Id}) => Id === contractId)
      // this.keys["Appendix.Id"].attrs.items = contract?.Appendixes
    },
    async changeContract(contract) {
      if (!contract) return
      this.invoice.Contract = {...contract}
      // this.keys["Appendix.Id"].attrs.items = contract?.Appendixes || []
      this.invoice.Contract = {...contract}
      this.invoice.Buyer = {...contract.Buyer}
      const id = contract.Buyer.Id
      const ttn = await waybillService.getCompanyById(id)
      this.keys["Waybill.Id"].attrs.items = ttn.data
    },
    async changeWaybill(Id) {
      const TTN = await waybillService.getById(Id)
      if (TTN.data.ShowShipmentDate === true) {
        this.invoice.InvoiceDate = TTN.data.ShipmentDate
      } else {
        this.invoice.InvoiceDate = ''
        this.$notify({
          group: 'mgs',
          type: 'error',
          title: 'ОШИБКА не указана дата в ТТН'
        })
      }
    },
    async formCallBack(data, input) {
      input.isEdit = false
      const response = await this.storeType(data)
      const id = response.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }

      this.invoice.Id = response.data?.Id
      this.invoice.Number = response.data?.Number
      this.invoice = response.data
      if (!this.id) {
        await this.$router.replace({
          path: `/invoice/${id}`,
          replace: true
        })
      }
      this.openPdf(id, 'invoice/print')
    },
    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    },
  },
  watch: {
    // async 'invoice.Buyer.Id'(id) {
    //   if (id && this.loading === true) {
    //     const buyer = this.keys["Buyer.Id"].attrs.items?.find(({Id}) => Id === id)
    //     this.invoice.Buyer = {...buyer}
    //     const contractId = this.invoice.Contract.Id
    //     this.invoice.Contract = {
    //       Id: '',
    //       Number: ''
    //     }
    //     this.invoice.Appendix = {
    //       Id: '',
    //       Number: ''
    //     }
    //     this.invoice.Waybill = {
    //       Id: '',
    //       Number: ''
    //     }
    //     const ttn = await waybillService.getCompanyById(id)
    //     this.keys["Waybill.Id"].attrs.items = ttn.data
    //     const contracts = await contractsService.contractCompanyById({companyId: buyer.Id})
    //     this.keys["Contract.Id"].attrs.items = contracts.data
    //     const contract = contracts.data.find(({Id}) => Id === contractId)
    //     this.keys["Appendix.Id"].attrs.items = contract?.Appendixes
    //   }
    // },
    // async 'invoice.Contract.Id'(id) {
    //   if (id && this.loading === true) {
    //     const contract = this.keys["Contract.Id"].attrs.items?.find(({Id}) => Id === id)
    //     this.invoice.Contract = contract
    //     this.keys["Appendix.Id"].attrs.items = contract?.Appendixes
    //   }
    // },
    // async 'invoice.Appendix.Id'(id) {
    //   if (id && this.loading === true) {
    //     const appendix = this.keys["Appendix.Id"].attrs.items?.find(({Id}) => Id === id)
    //     this.invoice.Appendix = appendix
    //   }
    // },
    async 'invoice.Waybill.Id'(id) {
      if (id && this.loading === true) {
        const waybill = this.keys["Waybill.Id"].attrs.items?.find(({Id}) => Id === id)
        this.invoice.Waybill = waybill
        this.invoice.Number = waybill?.Number;
      }
    },
  }
}
</script>
<style>
.z-index {
  z-index: 1500;
}
</style>